import React, { useEffect, useRef } from 'react';
import Plyr from 'plyr';
import { useSelected } from 'slate-react';
import { VideoContainer } from './File.styled';

// Based on https://github.com/sampotts/plyr/blob/master/src/js/support.js#L11
//
// Currently Plyr requires a prepared player instance to confirm if a video type
// is fully supported, through `plyr/support`. A very naive implementation of this
// is to simply check the mime type, which is OK but not 100% guaranteed.
const supportedVideoTypes = ['video/webm', 'video/mp4', 'video/ogg'];

export type FileVideoProps = {
  type?: string;
  src: string;
};

export const isSupportedVideoType = (type: string) =>
  supportedVideoTypes.indexOf(type) !== -1;

export const FileVideo = (props: FileVideoProps) => {
  const ref = useRef<HTMLVideoElement>(null);
  const { src, type } = props;
  const isSelected = useSelected();

  useEffect(() => {
    if (ref.current) Plyr.setup([ref.current]);
  }, []);

  /* eslint-disable jsx-a11y/media-has-caption */
  return (
    <VideoContainer
      isSelected={isSelected}
      data-testid="video-block"
      aria-current={isSelected}
    >
      <video ref={ref} controls preload="metadata">
        <source data-testid="video-block-source" src={src} type={type} />
      </video>
    </VideoContainer>
  );
  /* eslint-enable jsx-a11y/media-has-caption */
};
